import { IconShieldCheck as TablerIconShieldCheck } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconShieldCheck = /*#__PURE__*/ createOutlineIcon(
  TablerIconShieldCheck,
  'IconShieldCheck',
);
